import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'

export default class extends Controller {
  static targets = ['segment', 'domain', 'industry']
  static values = {
    getUrl: String,
    createUrl: String
  }

  connect() {
    this._initializeSegmentSelect()
    this._initializeConditionalSelects()
  }

  disconnect() {
    if (this.segmentSelect) {
      this.segmentSelect.destroy()
    }
    if (this.domainSelect) {
      this.domainSelect.destroy()
    }
    if (this.industrySelect) {
      this.industrySelect.destroy()
    }
  }

  _initializeSegmentSelect() {
    if (!this.hasSegmentTarget) return

    const options = Array.from(this.segmentTarget.options).map(option => ({
      value: option.value,
      text: option.text
    }))

    this.segmentSelect = new TomSelect(this.segmentTarget, {
      options: options,
      maxOptions: null,
      onItemAdd: function () {
        this.setTextboxValue('')
      },
      plugins: {
        remove_button: {
          title: 'remove'
        }
      }
    })

    this.segmentSelect.on('change', (value) => {
      this._updateConditionalSelects(value)
    })
  }

  _initializeConditionalSelects() {
    if (this.hasDomainTarget) {
      this._initializeConditionalSelect(this.domainTarget, 'domain')
    }

    if (this.hasIndustryTarget) {
      this._initializeConditionalSelect(this.industryTarget, 'industry')
    }
  }

  _initializeConditionalSelect(element, classificationType) {
    const tomSelect = new TomSelect(element, {
      valueField: 'id',
      labelField: 'name',
      searchField: 'name',
      maxOptions: null,
      create: (input, callback) => {
        this._createClassification(classificationType, input, callback)
      },
      onItemAdd: function () {
        this.setTextboxValue('')
      },
      plugins: {
        remove_button: {
          title: 'remove'
        }
      }
    })

    if (classificationType === 'domain') {
      this.domainSelect = tomSelect
    } else {
      this.industrySelect = tomSelect
    }
  }

  _updateConditionalSelects(segmentValue) {
    if (this.domainSelect) {
      this.domainSelect.clear()
      this.domainSelect.clearOptions()
    }

    if (this.industrySelect) {
      this.industrySelect.clear()
      this.industrySelect.clearOptions()
    }

    if (segmentValue) {
      this._loadAllOptionsFor('domain', segmentValue)
      this._loadAllOptionsFor('industry', segmentValue)
    }
  }

  _loadAllOptionsFor(classificationType, segment) {
    let url = `${this.getUrlValue}?classification_type=${classificationType}&segment=${segment}`

    fetch(url, {
      headers: {
        Accept: 'application/json'
      }
    })
      .then(response => response.json())
      .then(json => {
        const select = classificationType === 'domain' ? this.domainSelect : this.industrySelect

        if (select && json && json.length > 0) {
          json.forEach(item => {
            select.addOption({
              id: item.id,
              name: item.name
            })
          })
        }
      })
      .catch((error) => {
        console.error(`Error loading ${classificationType} options:`, error)
      })
  }

  _createClassification(classificationType, name, callback) {
    const segment = this.segmentSelect.getValue()

    fetch(this.createUrlValue, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({
        name: name,
        classification_type: classificationType,
        segment: segment
      })
    })
      .then(response => response.json())
      .then(data => {
        callback({
          id: data.id,
          name: data.name
        })
      })
      .catch(error => {
        console.error('Error creating classification:', error)
        callback()
      })
  }
}
